import React, { Fragment } from "react"

import { groupOrderCombos } from "utils"
import OhOrderCard from "./OhOrderCard"
import classes from "./OhGroupedOrderCard.module.scss"

const OhGroupedOrderCard = props => {
  const { order } = props

  const orderItems =
    order.items.filter(item => !item.comboSet)

  const combos = groupOrderCombos(order)

  return (
    <Fragment>
      {orderItems.map(orderItem => (
        <div
          key={orderItem._id}
          className={classes["order-item"]}>
          <OhOrderCard orderItem={orderItem} />
        </div>
      ))}
      {combos.map((combo, cIndex) =>
        <div
          key={cIndex}
          className={classes["combo"]}
        >
          <div className={classes["combo-name"]}>
            {combo.name}
          </div>
          <div className={classes["order-items"]}>
            {combo.items.map(comboItem =>
              <div
                key={comboItem._id}
                className={classes["order-item"]}
              >
                <OhOrderCard
                  orderItem={comboItem}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  )
}

export default OhGroupedOrderCard